import { Row, Col, Container, Form, Button, Table } from "react-bootstrap";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const QuoteSubmitComponent = ({
  createQuote,
  uploadImagesApiRequest,
  uploadImagesCloudinaryApiRequest,
  fromProductList,
  // userInfo,
}) => {
  const [validated, setValidated] = useState(false);
  const [images, setImages] = useState(false);
  const [quoteData, setQuoteData] = useState();
  const [isCreating, setIsCreating] = useState("");
  const [btnMessage, setBtnMessage] = useState("Submit Quote");
  const { userInfo } = useSelector((state) => state.userRegisterLogin);
  const [createQuoteResponseState, setCreateQuoteResponseState] = useState({
    message: "",
    error: "",
  });

  const emptyItem = {
    name: "",
    description: "",
    quantity: "",
    quoteType: "",
    images: [],
  };
  const [quoteItems, setQuoteItems] = useState([emptyItem]);
  const navigate = useNavigate();

  const formRef = useRef(null);
  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget.elements;

    const formInputs = {
      existingProduct: false,
      status: "Received",
      submittedAt: new Date(),
      createdBy: userInfo?.name + " " + userInfo?.lastName,
      items: quoteItems.map((item) => ({
        productName: item.name,
        userDescription: item.description,
        quoteType: item.quoteType,
        quantity: Number(item.quantity),
        existingProduct: false,
        clientImages: [],
      })),
    };

    if (event.currentTarget.checkValidity() === true) {
      if (images.length > 9) {
        setIsCreating("too many files");
        return;
      }
      setBtnMessage("Submitting...");

      createQuote(formInputs)
        .then((data) => {
          for (const item of quoteItems) {
            if (item?.images?.length > 0) {
              if (process.env.NODE_ENV === "dev") {
                uploadImagesApiRequest(item.images, data.quoteId)
                  .then((res) => { })
                  .catch((er) =>
                    setIsCreating(
                      er.response.data.message
                        ? er.response.data.message
                        : er.response.data
                    )
                  );
              } else {
                setQuoteData(data.quoteId);
                uploadImagesCloudinaryApiRequest(item.images, data.quoteId)
                  .then(() => {
                    setCreateQuoteResponseState({
                      message: "Quote submitted successfully.",
                      error: "",
                    });
                    setBtnMessage("Submit Quote");
                    if (formRef.current) {
                      formRef.current.reset();
                    }
                    setImages(null);
                    setIsCreating("");
                    setValidated(false);
                  })
                  .catch((uploadError) => {
                    setCreateQuoteResponseState({
                      error:
                        uploadError.message ||
                        "An error occurred during image upload.",
                    });
                  });
              }
            } else {
              setCreateQuoteResponseState({
                message: "Quote submitted successfully.",
                error: "",
              });
              setBtnMessage("Submit Quote");
              if (formRef.current) {
                formRef.current.reset();
              }
              setImages(null);
              setIsCreating("");
              setValidated(false);
            }
          }
        })
        .catch((er) => {
          console.error("Error creating quote:", er);
          setCreateQuoteResponseState({
            error: er.response.data.message
              ? er.response.data.message
              : er.response.data,
          });
        });
    }

    setValidated(true);
  };

  const uploadHandlerImage = (e) => {
    const newImages = e.target.files;
    if (newImages.length === 0) {
      return;
    }
    setImages(newImages);
  };

  const checkKeyDown = (e) => {
    if (e.code === "Enter") e.preventDefault();
  };

  const displayImages = () => {
    return (
      images &&
      Array.from(images).map((image, index) => (
        <img
          src={URL.createObjectURL(image)}
          key={index}
          alt="Selected"
          style={{ margin: "2px", width: "19%", height: "auto" }}
        />
      ))
    );
  };


  const handleItemChange = (index, field, value) => {
    const updatedItems = [...quoteItems];
    updatedItems[index][field] = value;
    setQuoteItems(updatedItems);
  };

  const handleItemImagesChange = (index, files) => {
    const updatedItems = [...quoteItems];

    updatedItems[index] = {
      ...updatedItems[index],
      images: Array.from(files),
    };
    setQuoteItems(updatedItems);
  };

  const addProductItem = () => {
    setQuoteItems([...quoteItems, { ...emptyItem }]);
  };

  const removeProductItem = (index) => {
    setQuoteItems(quoteItems.filter((_, i) => i !== index));
  };

  return (
    <Container>
      <h1 className="mt-3" hidden={fromProductList !== true}>
        REQUEST FOR QUOTE
      </h1>

      <Form
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
        onKeyDown={(e) => checkKeyDown(e)}
        ref={formRef}
      >

        <Table bordered responsive className="mt-3">
          <thead>
            <tr>
              <th style={{ width: "20%" }}>Product Name</th>
              <th style={{ width: "30%" }}>Description</th>
              <th style={{ width: "12%" }}>Quantity</th>
              <th style={{ width: "18%" }}>Quote Type</th>
              <th style={{ width: "15%" }}>Images</th>
              <th style={{ width: "5%" }}></th>
            </tr>
          </thead>

          <tbody>
            {quoteItems.map((item, index) => (
              <tr key={index}>
                {/* PRODUCT NAME */}
                <td>
                  <Form.Control
                    required
                    type="text"
                    value={item.name}
                    placeholder="Product name"
                    onChange={(e) =>
                      handleItemChange(index, "name", e.target.value)
                    }
                  />
                </td>

                {/* DESCRIPTION */}
                <td>
                  <Form.Control
                    required
                    as="textarea"
                    rows={2}
                    value={item.description}
                    placeholder="Description"
                    onChange={(e) =>
                      handleItemChange(index, "description", e.target.value)
                    }
                  />
                </td>

                {/* QUANTITY */}
                <td>
                  <Form.Control
                    required
                    type="number"
                    min={1}
                    value={item.quantity}
                    onChange={(e) =>
                      handleItemChange(index, "quantity", e.target.value)
                    }
                  />
                </td>

                {/* QUOTE TYPE */}
                <td>
                  <Form.Select
                    required
                    value={item.quoteType}
                    onChange={(e) =>
                      handleItemChange(index, "quoteType", e.target.value)
                    }
                  >
                    <option value="">Select</option>

                    <option value="Exact_Product_Required">
                      Exact Product Required
                    </option>

                    <option value="Alternative_Accepted">
                      Alternative Accepted
                    </option>
                  </Form.Select>
                </td>

                {/* IMAGE */}
                <td>
                  <Form.Control
                    type="file"
                    multiple
                    onChange={(e) =>
                      handleItemImagesChange(index, e.target.files)
                    }
                  />

                  <div className="d-flex flex-wrap mt-1">
                    {item.images?.map((img, imgIndex) => (
                      <img
                        key={imgIndex}
                        src={URL.createObjectURL(img)}
                        alt=""
                        style={{
                          width: "40px",
                          height: "40px",
                          objectFit: "cover",
                          marginRight: "4px",
                          marginBottom: "4px",
                          borderRadius: "4px",
                        }}
                      />
                    ))}
                  </div>
                </td>

                {/* REMOVE BUTTON */}
                <td className="text-center">
                  {quoteItems.length > 1 && (
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => removeProductItem(index)}
                    >
                      ×
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <div className="d-flex mt-3">
          <Button
            variant="secondary"
            type="button"
            onClick={addProductItem}
          >
            + Add Product
          </Button>

          <Button
            className="CTL_btn ms-2"
            type="submit"
            disabled={btnMessage === "Submitting..."}
          >
            {btnMessage}
          </Button>
        </div>
      </Form>

      <span className="text-success mt-2">{createQuoteResponseState.message}</span>
    </Container>
  );
};

export default QuoteSubmitComponent;
